import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  list: [],
  one: {},
  haveAnyChangesBeenDetected: false,
};

const getters = {
  list: state => state.list,
  one: state => state.one,
  haveAnyChangesBeenDetected: state => state.haveAnyChangesBeenDetected,
  isAnyAgentsOrDepartmentsHaveBeenAssigned: (state) => {
    const widgetConfig = state.one.config;

    // eslint-disable-next-line camelcase
    if (widgetConfig?.call_behavior === 'agents_group') {
      return widgetConfig.call_behavior_agents_group !== null;
    }

    // eslint-disable-next-line camelcase
    if (widgetConfig?.call_behavior === 'virtual_department') {
      return widgetConfig.call_behavior_virtual_departments !== null;
    }

    return true;
  },
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
